import { __assign } from "tslib";
import React from 'react';
import Item from '../parts/item';
import { getItemProps } from './get-item-props';
export var renderOptions = function (options, getOptionProps, filteringValue, isKeyboard, checkboxes, virtualItems) {
    if (isKeyboard === void 0) { isKeyboard = false; }
    if (checkboxes === void 0) { checkboxes = false; }
    return options.map(function (option, index) {
        var virtualItem = virtualItems && virtualItems[index];
        var globalIndex = virtualItem ? virtualItem.index : index;
        var props = getItemProps({
            option: option,
            index: globalIndex,
            getOptionProps: getOptionProps,
            filteringValue: filteringValue,
            isKeyboard: isKeyboard,
            checkboxes: checkboxes
        });
        return (React.createElement(Item, __assign({ key: globalIndex }, props, { virtualPosition: virtualItem && virtualItem.start, ref: virtualItem && virtualItem.measureRef })));
    });
};
